import React from 'react';
import './level1.css'
import Header from '../components/layout/header';
import pic11 from '../assets/pic11.png'
import pic48 from '../assets/pic48.png'
import Settings from '../components/common/settings';
import pic53 from '../assets/pic53.png'
import pic55 from '../assets/pic55.png'
import pic56 from '../assets/pic56.png'
import pic54 from '../assets/pic54.png'
import pic57 from '../assets/pic57.png'
import pic58 from '../assets/pic58.png'
import pic59 from '../assets/pic59.png'
import pic69 from '../assets/pic69.png'
import pic70 from '../assets/pic70.png'
import pic71 from '../assets/pic71.png'
import pic72 from '../assets/pic72.png'
import pic73 from '../assets/pic73.png'
import pic81 from '../assets/pic81.png'
import pic74 from '../assets/pic74.png'
import pic75 from '../assets/pic75.png'
import pic76 from '../assets/pic76.png'
import pic77 from '../assets/pic77.png'
import pic78 from '../assets/pic78.png'
import pic79 from '../assets/pic79.png'
import pic80 from '../assets/pic80.png'
import pic91 from '../assets/pic91.png'
import pic92 from '../assets/pic92.png'
import AudioContext from '../components/common/AudioContext';
import collect from '../audio/collect.mp3';
import { useNavigate } from 'react-router-dom';
import pic93 from '../assets/pic93.png'
import wrong from '../audio/wrong.mp3';
import Pause from '../components/common/pause';
import './level2.css'
import pic125 from '../assets/pic125.png'
import pic126 from '../assets/pic126.png'
import pic127 from '../assets/pic127.png'
import pic128 from '../assets/pic128.png'
import pic137 from '../assets/pic137.png'
import pic138 from '../assets/pic138.png'
import { useEffect } from 'react';
import { useState } from 'react';
import pic122 from '../assets/pic122.png'
import './level4.css'
import pic156 from '../assets/pic156.png'
import pic157 from '../assets/pic157.png'
import pic158 from '../assets/pic158.png'
import pic159 from '../assets/pic159.png'
import pic161 from '../assets/pic161.png'
import pic162 from '../assets/pic162.png'
import pic163 from '../assets/pic163.png'
import pic164 from '../assets/pic164.png'
import pic165 from '../assets/pic165.png'
import pic166 from '../assets/pic166.png'
import pic167 from '../assets/pic167.png'
import pic168 from '../assets/pic168.png'
import pic169 from '../assets/pic169.png'
import pic170 from '../assets/pic170.png'
import pic171 from '../assets/pic171.png'
import pic172 from '../assets/pic172.png'
import pic192 from '../assets/pic192.png'
import pic193 from '../assets/pic193.png'
import pic194 from '../assets/pic194.png'
import pic195 from '../assets/pic195.png'
import pic196 from '../assets/pic196.png'
import pic197 from '../assets/pic197.png'
import pic198 from '../assets/pic198.png'
import pic199 from '../assets/pic199.png'
import pic200 from '../assets/pic200.png'
import pic201 from '../assets/pic201.png'
import pic202 from '../assets/pic202.png'
import pic203 from '../assets/pic203.png'
import pic204 from '../assets/pic204.png'
import pic205 from '../assets/pic205.png'
import pic206 from '../assets/pic206.png'
import pic207 from '../assets/pic207.png'
import pic129 from '../assets/pic129.png'
import pic208 from '../assets/pic208.png'
import pic209 from '../assets/pic209.png'
import pic210 from '../assets/pic210.png'
import pic211 from '../assets/pic211.png'
import pic212 from '../assets/pic212.png'
import pic213 from '../assets/pic213.png'
import pic214 from '../assets/pic214.png'
import pic215 from '../assets/pic215.png'
import pic216 from '../assets/pic216.png'
import pic217 from '../assets/pic217.png'
import pic218 from '../assets/pic218.png'
import pic219 from '../assets/pic219.png'
import pic132 from '../assets/pic132.png'
import pic220 from '../assets/pic220.png'
import pic190 from '../assets/pic190.png'
import pic229 from '../assets/pic229.png'
import dangerTime from '../audio/Dangertime.mp3';

const Level4 = () => {
     const navigate = useNavigate();
     const rafRef = React.useRef(null);
    const timerRef = React.useRef(null);
      const [settingsOpen, setSettingsOpen] = useState(false);
      const selectedCharacter =
    localStorage.getItem('selectedCharacter') || 'Mohammed Tout';

        const { soundVolume } = React.useContext(AudioContext);
       const audioRef = React.useRef(null)
      const [pauseOpen, setPauseOpen] = useState(false);
      const isPaused = pauseOpen || settingsOpen;
        const gameRef = React.useRef(null);
        const [characterX, setCharacterX] = useState(167);
        const [lives, setLives] = useState(3);
        const [hitObstacles, setHitObstacles] = useState([]);
        const [collectedItems, setCollectedItems] = useState([]);
        const livesRef = React.useRef(lives);
        const collectedRef = React.useRef(collectedItems);
        const remainingRef = React.useRef(24880);
        const startRef = React.useRef(null);
        const hitObstaclesRef = React.useRef(new Set());
        const collectedRefSet = React.useRef(new Set());        
        const remainingCount = 7 - collectedItems.length;
            const moveCharacter = (clientX, clientY) => {
            if (isPaused) return;
            if (clientY < 160) return;
            const container = gameRef.current;
            if (!container) return;
            const rect = container.getBoundingClientRect();
            const characterWidth = 166;
            let newX = clientX - rect.left - characterWidth / 2;
            newX = Math.max(
                0, Math.min(rect.width - characterWidth, newX));
            setCharacterX(newX); };


    const [hiddenHudItems, setHiddenHudItems] = useState([]);
        const [hitObstacle, setHitObstacle] = useState(null);
        const obstacle1Ref = React.useRef(null);
        const obstacle2Ref = React.useRef(null);
        const obstacle3Ref = React.useRef(null);
        const obstacle4Ref = React.useRef(null);
        const obstacle5Ref = React.useRef(null);
        const obstacle6Ref = React.useRef(null);
        const obstacle7Ref = React.useRef(null);
        const obstacle8Ref = React.useRef(null);
        const obstacle9Ref = React.useRef(null);
        const obstacle10Ref = React.useRef(null);
        const obstacle11Ref = React.useRef(null);
        const obstacle12Ref = React.useRef(null);
        const obstacle13Ref = React.useRef(null);
        const obstacle14Ref = React.useRef(null);
        const obstacle15Ref = React.useRef(null);
        const obstacle16Ref = React.useRef(null);
        const obstacle17Ref = React.useRef(null);
        const obstacle18Ref = React.useRef(null);
        const obstacle19Ref = React.useRef(null);
        const obstacle20Ref = React.useRef(null);
        const obstacle21Ref = React.useRef(null);
        const obstacle22Ref = React.useRef(null);
        const obstacle23Ref = React.useRef(null);
        const obstacle24Ref = React.useRef(null);
        const obstacle25Ref = React.useRef(null);   
        const obstacle26Ref = React.useRef(null);         
        const obstacle27Ref = React.useRef(null);          
        const obstacle28Ref = React.useRef(null);   
        const obstacle29Ref = React.useRef(null);     
        const obstacle30Ref = React.useRef(null);                 
        const obstacle31Ref = React.useRef(null);
        const obstacle32Ref = React.useRef(null);   
        const obstacle33Ref = React.useRef(null); 
        const obstacle34Ref = React.useRef(null);   
        const obstacle35Ref = React.useRef(null);   
        const obstacle36Ref = React.useRef(null);            
        const obstacle37Ref = React.useRef(null);           
        const obstacle38Ref = React.useRef(null); 
        const obstacle39Ref = React.useRef(null);  
        const obstacle40Ref = React.useRef(null);  
        const obstacle41Ref = React.useRef(null);   
        const obstacle42Ref = React.useRef(null);  
        const obstacle43Ref = React.useRef(null);    
        const obstacle44Ref = React.useRef(null);   
        const obstacle45Ref = React.useRef(null);        
        const obstacle46Ref = React.useRef(null);  
        const obstacle47Ref = React.useRef(null);   
        const obstacle48Ref = React.useRef(null);   
        const obstacle49Ref = React.useRef(null);                    
        const obstacle50Ref = React.useRef(null);   
        const obstacle51Ref = React.useRef(null);     
        const obstacle52Ref = React.useRef(null);    
        const obstacle53Ref = React.useRef(null); 
        const obstacle54Ref = React.useRef(null);  
        const obstacle55Ref = React.useRef(null);    
        const obstacle56Ref = React.useRef(null);                        
        const obstacle57Ref = React.useRef(null); 
        const obstacle58Ref = React.useRef(null);   
        const obstacle59Ref = React.useRef(null);                   
        const obstacle60Ref = React.useRef(null);
        const obstacle61Ref = React.useRef(null);
        const obstacle62Ref = React.useRef(null);
        const obstacle63Ref = React.useRef(null);
        const obstacle64Ref = React.useRef(null);
        const obstacle65Ref = React.useRef(null);
        const obstacle66Ref = React.useRef(null);
        const obstacle67Ref = React.useRef(null);
        const obstacle68Ref = React.useRef(null);

        const collect1Ref = React.useRef(null);
        const collect2Ref = React.useRef(null);
        const collect3Ref = React.useRef(null);
        const collect4Ref = React.useRef(null);
        const collect5Ref = React.useRef(null);
        const collect6Ref = React.useRef(null);
        const collect7Ref = React.useRef(null);        

        const collectAudioRef = React.useRef(null);
        const dangerAudioRef = React.useRef(null);

        const checkCollision = (characterRect, obstacleRect) => {
        const centerX = characterRect.left + characterRect.width / 2;
        const centerY = characterRect.top + characterRect.height / 2;

        return (
            centerX >= obstacleRect.left &&
            centerX <= obstacleRect.right &&
            centerY >= obstacleRect.top &&
            centerY <= obstacleRect.bottom
        );
    };
        const characterRef = React.useRef(null);

        const [timeLeft, setTimeLeft] = useState(24);
                useEffect(() => {
            if (isPaused) return;

            const interval = setInterval(() => {
                setTimeLeft(prev => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);

        }, [isPaused]);


useEffect(() => {
    const checkLoop = () => {
        if (characterRef.current && !isPaused) {
            const characterRect = characterRef.current.getBoundingClientRect();

            const obstacles = [
                { id: 1, ref: obstacle1Ref },
                { id: 2, ref: obstacle2Ref },
                { id: 3, ref: obstacle3Ref },
                { id: 4, ref: obstacle4Ref },
                { id: 5, ref: obstacle5Ref },
                { id: 6, ref: obstacle6Ref },
                { id: 7, ref: obstacle7Ref },
                { id: 8, ref: obstacle8Ref },
                { id: 9, ref: obstacle9Ref },
                { id: 10, ref: obstacle10Ref },
                { id: 11, ref: obstacle11Ref },
                { id: 12, ref: obstacle12Ref },
                { id: 13, ref: obstacle13Ref },
                { id: 14, ref: obstacle14Ref },
                { id: 15, ref: obstacle15Ref },
                { id: 16, ref: obstacle16Ref },
                { id: 17, ref: obstacle17Ref },
                { id: 18, ref: obstacle18Ref },
                { id: 19, ref: obstacle19Ref },
                { id: 20, ref: obstacle20Ref },
                { id: 21, ref: obstacle21Ref },
                { id: 22, ref: obstacle22Ref },
                { id: 23, ref: obstacle23Ref },
                { id: 24, ref: obstacle24Ref },
                { id: 25, ref: obstacle25Ref },      
                { id: 26, ref: obstacle26Ref }, 
                { id: 27, ref: obstacle27Ref },    
                { id: 28, ref: obstacle28Ref },  
                { id: 29, ref: obstacle29Ref },                                            
                { id: 30, ref: obstacle30Ref },   
                { id: 31, ref: obstacle31Ref },  
                { id: 32, ref: obstacle32Ref },  
                { id: 33, ref: obstacle33Ref },  
                { id: 34, ref: obstacle34Ref },   
                { id: 35, ref: obstacle35Ref },   
                { id: 36, ref: obstacle36Ref },     
                { id: 37, ref: obstacle37Ref },   
                { id: 38, ref: obstacle38Ref },   
                { id: 39, ref: obstacle39Ref },
                { id: 40, ref: obstacle40Ref }, 
                { id: 41, ref: obstacle41Ref }, 
                { id: 42, ref: obstacle42Ref },    
                { id: 43, ref: obstacle43Ref }, 
                { id: 44, ref: obstacle44Ref }, 
                { id: 45, ref: obstacle45Ref },   
                { id: 46, ref: obstacle46Ref },  
                { id: 47, ref: obstacle47Ref },    
                { id: 48, ref: obstacle48Ref },  
                { id: 49, ref: obstacle49Ref },    
                { id: 50, ref: obstacle50Ref },   
                { id: 51, ref: obstacle51Ref },   
                { id: 52, ref: obstacle52Ref },  
                { id: 53, ref: obstacle53Ref },    
                { id: 54, ref: obstacle54Ref },     
                { id: 55, ref: obstacle55Ref },  
                { id: 56, ref: obstacle56Ref },  
                { id: 57, ref: obstacle57Ref },     
                { id: 58, ref: obstacle58Ref },  
                { id: 59, ref: obstacle59Ref },   
                { id: 60, ref: obstacle60Ref },     
                { id: 61, ref: obstacle61Ref }, 
                { id: 62, ref: obstacle62Ref },                                  
                { id: 63, ref: obstacle63Ref },     
                { id: 64, ref: obstacle64Ref },   
                { id: 65, ref: obstacle65Ref },                  
                { id: 66, ref: obstacle66Ref },  
                { id: 67, ref: obstacle67Ref },      
                { id: 68, ref: obstacle68Ref },          
                
            ];

            for (const obstacle of obstacles) {
                if (!obstacle.ref.current) continue;

                const obstacleRect = obstacle.ref.current.getBoundingClientRect();

                if (checkCollision(characterRect, obstacleRect)) {
                    if (!hitObstaclesRef.current.has(obstacle.id)) {
                        hitObstaclesRef.current.add(obstacle.id);

                        setHitObstacle(obstacle.id);
                        setHitObstacles(prev => [...prev, obstacle.id]);
                        setLives(prev => prev - 1);

                        audioRef.current?.play().catch(() => {});

                        console.log("HIT", obstacle.id);
                    }
                    break;
                }
            }

            const collectibles = [
                { id: 1, ref: collect1Ref },
                { id: 2, ref: collect2Ref },
                { id: 3, ref: collect3Ref },
                { id: 4, ref: collect4Ref },
                { id: 5, ref: collect5Ref }, 
                { id: 6, ref: collect6Ref },   
                { id: 7, ref: collect7Ref },                                
            ];

            for (const item of collectibles) {
                if (!item.ref.current) continue;

                const itemRect = item.ref.current.getBoundingClientRect();

                if (checkCollision(characterRect, itemRect)) {
                if (!collectedRefSet.current.has(item.id)) {
                    collectedRefSet.current.add(item.id);

                    setCollectedItems(prev => {
                        const updated = [...prev, item.id];

                        if (updated.length <= 2) {
                            setTimeout(() => {
                                setHiddenHudItems(prevHidden => [
                                    ...prevHidden,
                                    item.id
                                ]);
                            }, 2700);
                        }

                        return updated;
                    });

                    collectAudioRef.current?.play().catch(() => {});
                }
            }
            }
        }

        rafRef.current = requestAnimationFrame(checkLoop);
    };

    rafRef.current = requestAnimationFrame(checkLoop);

    return () => cancelAnimationFrame(rafRef.current);
}, [isPaused, hitObstacles, collectedItems]);



       useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

        audio.volume = soundVolume;
    }, [soundVolume]);


    useEffect(() => {
        console.log("Lives:", lives);
    }, [lives]);
    

        useEffect(() => {
            if (audioRef.current) audioRef.current.volume = soundVolume;
        }, [soundVolume]);

        useEffect(() => {
            if (collectAudioRef.current) collectAudioRef.current.volume = soundVolume;
        }, [soundVolume]);


        useEffect(() => {
        if (lives <= 0) {


        const level4Score = collectedItems.length * 1000 + lives * 200;
        localStorage.setItem('level4Score', level4Score);

        const previousL1 = Number(localStorage.getItem('level1Score')) || 0;
        const previousL2 = Number(localStorage.getItem('level2Score')) || 0;
        const previousL3 = Number(localStorage.getItem('level3Score')) || 0;
        const totalScore = previousL1 + previousL2 + previousL3 + level4Score;

           navigate('/losing', {
                   state: {
                    score: totalScore,
                    lives,
                    collected: collectedItems.length,
                    loseReason: 'obstacles',
                    level: 4
                }
            });
        }
    }, [lives, navigate]);



        useEffect(() => {
            livesRef.current = lives;
        }, [lives]);

        useEffect(() => {
            collectedRef.current = collectedItems;
        }, [collectedItems]);


    useEffect(() => {
        const fireEnd = () => {

                const currentLives = livesRef.current;
                const currentCollected = collectedRef.current;

                 const level4Score = currentCollected.length * 1000 + currentLives * 200;
                localStorage.setItem('level4Score', level4Score);

                const level1Score = Number(localStorage.getItem('level1Score')) || 0;
                const level2Score = Number(localStorage.getItem('level2Score')) || 0;
                const level3Score = Number(localStorage.getItem('level3Score')) || 0;
                const totalScore = level1Score + level2Score + level3Score + level4Score;


                const hasAllItems =
                    currentCollected.includes(1) &&
                    currentCollected.includes(2) &&
                    currentCollected.includes(3) &&
                    currentCollected.includes(4) &&
                    currentCollected.includes(5) &&
                    currentCollected.includes(6) &&
                    currentCollected.includes(7)
                    ;     
                       
                if (currentLives > 0 && hasAllItems){
                console.log('Collected:', currentCollected);
                navigate('/wining', {
                    state: {
                          score: totalScore,
                        lives: currentLives,
                        collected: currentCollected.length,
                        level: 4
                    }
                });
            } else {
               navigate('/losing', {
                        state: {
                            score: totalScore,
                            lives: currentLives,
                            collected: currentCollected.length,
                            loseReason: 'artifacts',
                            level: 4
                        }
                    });
            }
        };

        if (!isPaused) {
            startRef.current = Date.now();

            timerRef.current = setTimeout(
                fireEnd,
                remainingRef.current
            );
        } else {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            if (startRef.current) {
                remainingRef.current -= Date.now() - startRef.current;
            }
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [isPaused]);


    useEffect(() => {
        if (collectedItems.length === 4) {
            const timer = setTimeout(() => {
                setHiddenHudItems(collectedItems);
            }, 900);

            return () => clearTimeout(timer);
        }
    }, [collectedItems]);


        useEffect(() => {

            if(timeLeft <= 10 && timeLeft > 0 && !isPaused){

                dangerAudioRef.current?.play()
                .catch(()=>{});

            }else{

                dangerAudioRef.current?.pause();
                dangerAudioRef.current.currentTime = 0;

            }

        },[timeLeft,isPaused]);



    return ( 
<main className='level1--page'>

     <audio ref={audioRef} src={wrong} preload="auto" />
     <audio ref={collectAudioRef} src={collect} preload="auto" />
                    <audio ref={dangerAudioRef} 
                       src={dangerTime} 
                       preload="auto" 
                       loop 
                       />
            <section
                ref={gameRef}
                className={`levelbackground--page ${isPaused ? 'paused' : ''}`}
                onMouseMove={(e) => moveCharacter(e.clientX, e.clientY)}
                onTouchMove={(e) =>
                moveCharacter(
                    e.touches[0].clientX,
                    e.touches[0].clientY
                )
                }
                >
                 {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
                         {pauseOpen && (
            <Pause
                onClose={() => setPauseOpen(false)}
                replayRoute="/level4start"
                   currentLevel="4"
            />
        )}
                <div   className='background-and-obstacles-layer-level4 '>
                    <div className='container-obtsacles-and-collections'>
                        <div className="obstacle-wrapper obstacle1-level4">{hitObstacle === 1 && ( <img className="wrong-sign" src={pic91} alt="wrong" /> )}
                        <img   ref={obstacle1Ref} src={pic192} alt='obstacle-1'/>
                        </div>

                        <div className="obstacle-wrapper obstacle2-level4">{hitObstacle === 2 && ( <img className="wrong-sign" src={pic91} alt="wrong" /> )}
                        <img ref={obstacle2Ref} src={pic193} alt='obstacle-2'/>
                        </div>

                        <div className="obstacle-wrapper obstacle3-level3-2">{hitObstacle === 3 && ( <img className="wrong-sign" src={pic91} alt="wrong" /> )}
                        <img ref={obstacle3Ref} src={pic194} alt='obstacle-3'/>
                        </div>

                        <div className="obstacle-wrapper obstacle4-level4">
                        {hitObstacle === 4 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle4Ref} src={pic125} alt="obstacle-4" />
                        </div>

                        <div className="obstacle-wrapper obstacle5-level4">
                        {hitObstacle === 5 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle5Ref} src={pic169} alt="obstacle-5" />
                        </div>

                       <div className="obstacle-wrapper obstacle6-level4">
                        {hitObstacle === 6 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle6Ref} src={pic159} alt="obstacle-6" />
                        </div>


                        <div className="obstacle-wrapper obstacle7-level4">
                        {hitObstacle === 7 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle7Ref} src={pic125} alt="obstacle-7" />
                        </div>


                        <div className="obstacle-wrapper obstacle8-level3">
                        {hitObstacle === 8 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle8Ref} src={pic77} alt="obstacle-8" />
                        </div>

                        <div className="obstacle-wrapper obstacle9-level4">
                        {hitObstacle === 9 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle9Ref} src={pic158} alt="obstacle-9" />
                        </div>

                        <div className="obstacle-wrapper obstacle10-level4 ">
                        {hitObstacle === 10 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle10Ref} src={pic161} alt="obstacle-10" />
                        </div>


                        <div className="obstacle-wrapper obstacle11-level4">
                        {hitObstacle === 15 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle15Ref} src={pic127} alt="obstacle-15" />
                        </div>

                        <div className="obstacle-wrapper obstacle12-level4">
                        {hitObstacle === 16 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle16Ref} src={pic78} alt="obstacle-16" />
                        </div>

                        <div className="obstacle-wrapper obstacle13-level4 ">
                        {hitObstacle === 17 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle17Ref} src={pic195} alt="obstacle-17" />
                        </div>

                        <div className="obstacle-wrapper obstacle14-level4">
                        {hitObstacle === 18 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle18Ref} src={pic69} alt="obstacle-18" />
                        </div>


                        <div className="obstacle-wrapper obstacle15-level4 ">
                        {hitObstacle === 19 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle19Ref} src={pic128} alt="obstacle-19" />
                        </div>

                      <img
                        ref={collect1Ref}
                        className={`collect1-level4  ${
                            collectedItems.includes(1) ? 'collected' : ''
                        }`}
                        src={pic196}
                        alt="collect-1"
                        />

                        <div className="obstacle-wrapper obstacle16-level4">
                        {hitObstacle === 20 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle20Ref} src={pic193} alt="obstacle-20" />
                        </div>

                         <div className="obstacle-wrapper obstacle17-level4">
                        {hitObstacle === 11 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle11Ref} src={pic57} alt="obstacle-11" />
                        </div>


                        <div className="obstacle-wrapper obstacle18-level4">
                        {hitObstacle === 14 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle14Ref} src={pic198} alt="obstacle-14" />
                        </div>

                        <div className="obstacle-wrapper obstacle19-level4">
                        {hitObstacle === 12 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle12Ref} src={pic57} alt="obstacle-12" />
                        </div>


                        <div className="obstacle-wrapper obstacle20-level4">
                        {hitObstacle === 21 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle21Ref} src={pic199} alt="obstacle-21" />
                        </div>


                        <div className="obstacle-wrapper obstacle21-level4">
                        {hitObstacle === 22 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle22Ref} src={pic200} alt="obstacle-22" />
                        </div>

                        <div className="obstacle-wrapper obstacle22-level4">
                        {hitObstacle === 23 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle23Ref} src={pic192} alt="obstacle-23" />
                        </div>

                        <div className="obstacle-wrapper obstacle23-level4">
                        {hitObstacle === 24 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle24Ref} src={pic166} alt="obstacle-24" />
                        </div>


                        <div className="obstacle-wrapper obstacle24-level4">
                        {hitObstacle === 25 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle25Ref} src={pic201} alt="obstacle-25" />
                        </div>

                       <div className="obstacle-wrapper obstacle25-level4">
                        {hitObstacle === 26 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle26Ref} src={pic126} alt="obstacle-26" />
                        </div>

                        <img
                        ref={collect2Ref}
                        className={`collect2-level4  ${
                            collectedItems.includes(2) ? 'collected' : ''
                        }`}
                        src={pic202}
                        alt="collect"
                        />


                       <div className="obstacle-wrapper obstacle26-level4">
                        {hitObstacle === 27 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle27Ref} src={pic125} alt="obstacle-27" />
                        </div>


                       <div className="obstacle-wrapper obstacle27-level4">
                        {hitObstacle === 28 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle28Ref} src={pic204} alt="obstacle-28" />
                       </div>

                       <div className="obstacle-wrapper obstacle28-level4">
                        {hitObstacle === 29 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle29Ref} src={pic205} alt="obstacle-29" />
                       </div>

                        <img
                            ref={collect3Ref}
                            className={`collect3-level4 ${
                                collectedItems.includes(3) ? 'collected' : ''
                            }`}
                            src={pic206}
                            alt="collect"
                            />

                       <div className="obstacle-wrapper obstacle29-level4">
                        {hitObstacle === 30 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle30Ref} src={pic69} alt="obstacle-30" />
                       </div>


                       <div className="obstacle-wrapper obstacle30-level4">
                        {hitObstacle === 31 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle31Ref} src={pic126} alt="obstacle-31" />
                       </div>


                       <div className="obstacle-wrapper obstacle31-level4">
                        {hitObstacle === 32 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle32Ref} src={pic208} alt="obstacle-32" />
                       </div>

                       <div className="obstacle-wrapper obstacle32-level4">
                        {hitObstacle === 33 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle33Ref} src={pic209} alt="obstacle-33" />
                       </div>


                       <div className="obstacle-wrapper obstacle33-level4">
                        {hitObstacle === 34 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle34Ref} src={pic127} alt="obstacle-34" />
                       </div>


                       <div className="obstacle-wrapper obstacle34-level4">
                        {hitObstacle === 35 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle35Ref} src={pic75} alt="obstacle-35" />
                       </div>


                        <img
                            ref={collect4Ref}
                            className={`collect4-level4 ${
                                collectedItems.includes(4) ? 'collected' : ''
                            }`}
                            src={pic210}
                            alt="collect"
                            />

                       <div className="obstacle-wrapper obstacle35-level4">
                        {hitObstacle === 36 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle36Ref} src={pic172} alt="obstacle-36" />
                       </div>


                       <div className="obstacle-wrapper obstacle36-level4">
                        {hitObstacle === 37 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle37Ref} src={pic158} alt="obstacle-37" />
                       </div>


                        <div className="obstacle-wrapper obstacle37-level4">
                        {hitObstacle === 38 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle38Ref} src={pic73} alt="obstacle-38" />
                       </div>         

                        <div className="obstacle-wrapper obstacle38-level4">
                        {hitObstacle === 39 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle39Ref} src={pic169} alt="obstacle-39" />
                       </div>             


                        <div className="obstacle-wrapper obstacle39-level4">
                        {hitObstacle === 40 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle40Ref} src={pic205} alt="obstacle-40" />
                       </div>    


                        <div className="obstacle-wrapper obstacle40-level4">
                        {hitObstacle === 41 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle41Ref} src={pic76} alt="obstacle-41" />
                       </div>    

                        <img
                            ref={collect5Ref}
                            className={`collect5-level4 ${
                                collectedItems.includes(5) ? 'collected' : ''
                            }`}
                            src={pic212}
                            alt="collect"
                            />

                        <div className="obstacle-wrapper obstacle41-level4">
                        {hitObstacle === 42 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle42Ref} src={pic126} alt="obstacle-42" />
                       </div>   


                        <div className="obstacle-wrapper obstacle42-level4">
                        {hitObstacle === 43 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle43Ref} src={pic158} alt="obstacle-42" />
                       </div>   

                     <div className="obstacle-wrapper obstacle43-level4">
                        {hitObstacle === 44 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle44Ref} src={pic214} alt="obstacle-42" />
                       </div>  


                        <div className="obstacle-wrapper obstacle44-level4">
                        {hitObstacle === 45 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle45Ref} src={pic209} alt="obstacle-42" />
                       </div> 


                        <div className="obstacle-wrapper obstacle45-level4">
                        {hitObstacle === 46 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle46Ref} src={pic76} alt="obstacle-42" />
                       </div>  


                        <div className="obstacle-wrapper obstacle46-level4">
                        {hitObstacle === 47 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle47Ref} src={pic166} alt="obstacle-42" />
                       </div>  


                        <img
                            ref={collect6Ref}
                            className={`collect6-level4 ${
                                collectedItems.includes(6) ? 'collected' : ''
                            }`}
                            src={pic216}
                            alt="collect"
                            />


                        <div className="obstacle-wrapper obstacle47-level4">
                        {hitObstacle === 48 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle48Ref} src={pic201} alt="obstacle-42" />
                       </div>   

                        <div className="obstacle-wrapper obstacle48-level4 ">
                        {hitObstacle === 49 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle49Ref} src={pic161} alt="obstacle-42" />
                       </div>   

                        <div className="obstacle-wrapper obstacle49-level4 ">
                        {hitObstacle === 50 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle50Ref} src={pic76} alt="obstacle-49" />
                       </div> 

                        <div className="obstacle-wrapper obstacle50-level4">
                        {hitObstacle === 51 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle51Ref} src={pic200} alt="obstacle-50" />
                       </div> 


                        <div className="obstacle-wrapper obstacle51-level4">
                        {hitObstacle === 52 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle52Ref} src={pic126} alt="obstacle-51" />
                       </div> 

                        <div className="obstacle-wrapper obstacle52-level4">
                        {hitObstacle === 53 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle53Ref} src={pic204} alt="obstacle-52" />
                       </div> 
                     

                        <div className="obstacle-wrapper obstacle53-level4">
                        {hitObstacle === 54 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle54Ref} src={pic161} alt="obstacle-53" />
                       </div> 


                        <div className="obstacle-wrapper obstacle54-level4">
                        {hitObstacle === 55 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle55Ref} src={pic200} alt="obstacle-54" />
                       </div> 

                        <div className="obstacle-wrapper obstacle55-level4">
                        {hitObstacle === 56 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle56Ref} src={pic57} alt="obstacle-55" />
                       </div> 


                        <img
                            ref={collect7Ref}
                            className={`collect7-level4 ${
                                collectedItems.includes(7) ? 'collected' : ''
                            }`}
                            src={pic217}
                            alt="collect"
                            />

                        <div className="obstacle-wrapper obstacle56-level4">
                        {hitObstacle === 57 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle57Ref} src={pic219} alt="obstacle-56" />
                       </div> 

                        <div className="obstacle-wrapper obstacle57-level4">
                        {hitObstacle === 58 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle58Ref} src={pic126} alt="obstacle-57" />
                       </div> 

                        <div className="obstacle-wrapper obstacle58-level4">
                        {hitObstacle === 59 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle59Ref} src={pic74} alt="obstacle-58" />
                       </div> 

                        <div className="obstacle-wrapper obstacle59-level4">
                        {hitObstacle === 60 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle60Ref} src={pic132} alt="obstacle-59" />
                       </div> 

                        <div className="obstacle-wrapper obstacle60-level4">
                        {hitObstacle === 61 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle61Ref} src={pic76} alt="obstacle-60" />
                       </div> 


                        <div className="obstacle-wrapper obstacle61-level4">
                        {hitObstacle === 62 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle62Ref} src={pic193} alt="obstacle-61" />
                       </div> 


                        <div className="obstacle-wrapper obstacle62-level4">
                        {hitObstacle === 63 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle63Ref} src={pic126} alt="obstacle-62" />
                       </div> 


                        <div className="obstacle-wrapper obstacle63-level4">
                        {hitObstacle === 64 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle64Ref} src={pic132} alt="obstacle-63" />
                       </div> 

                        <div className="obstacle-wrapper obstacle64-level4">
                        {hitObstacle === 65 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle65Ref} src={pic57} alt="obstacle-64" />
                       </div> 

                        <div className="obstacle-wrapper obstacle65-level4">
                        {hitObstacle === 67 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle67Ref} src={pic58} alt="obstacle-64" />
                       </div> 

                        <div className="obstacle-wrapper obstacle66-level4">
                        {hitObstacle === 68 && <img className="wrong-sign" src={pic91} alt="wrong" />}
                        <img ref={obstacle68Ref} src={pic220} alt="obstacle-64" />
                       </div> 



                    </div>
                </div>


             {/* <section className='container-items-home-page'>
               <section className='container-charcater-page'>
                    </section>
              </section> */}
   
                <section className='container-hedaer-and-character-levels-page'>
                    <Header 
                    title='Level 4' title2='Level 4'
                    onClick={() => setSettingsOpen(true)}
                    img={pic48} icontext='pause icon' onClick2={() => setPauseOpen(true)}
                    img2={pic11} icontext2='settings icon'/>
                <img
                    ref={characterRef}
                    className="character-movement"
                    src={
                         selectedCharacter === 'Ahmad Amon'
                         ? pic190
                        : selectedCharacter === 'Mariam Lotus'
                         ?pic229
                        : selectedCharacter === 'Teyah Ramses'
                         ? pic156
                        : selectedCharacter === 'Sarah Idress'
                            ? pic122
                            : pic54
                    }
                    alt="character"
                    style={{ left: `${characterX}px` }}
                />




                    <div className='HUD-container'>
                        
                             <div className='lives2-frame-Hud'>
                                <div className='lives-container2-HUD '>
                                    <h2   className={`timer-HUD ${timeLeft <= 10 ? 'danger-timer' : ''}`}>
                                Finish: {timeLeft}s
                                </h2>
                                </div>
                            </div>
                            <div className='lives-frame-Hud'>
                                <div className='lives-container-HUD'>
                                    <img className='decoration2-HUD' src={pic56} alt='decoration-HUD'></img>
                                    <div className='hearts-container'>
                                        <img src={lives >= 3 ? pic53 : pic93} alt='heart' />
                                        <img src={lives >= 2 ? pic53 : pic93} alt='heart' />
                                        <img src={lives >= 1 ? pic53 : pic93} alt='heart' />
                                    </div>
                                </div>
                            </div>

                        <div className='frame-Hud'>
                            <div className='HUD-1-container'>

                                <img className='decoration-HUD' src={pic55} alt='decoration-HUD'></img>

                                <h2 className='collect-text'>Collect:</h2>
                                <div className='row-pic-HUD'>
                                    {!hiddenHudItems.includes(1) && (
                                        <div className='img-container-HUD'>
                                            <img
                                                className={collectedItems.includes(1) ? 'collected-hud' : ''}
                                                src={pic197}
                                                alt='collect-item-1'
                                            />
                                        </div>
                                    )}

                                    {!hiddenHudItems.includes(2) && (
                                        <div className='img-container-HUD'>
                                            <img
                                                className={collectedItems.includes(2) ? 'collected-hud' : ''}
                                                src={pic203}
                                                alt='collect-item-2'
                                            />
                                        </div>
                                    )}
                                    {!hiddenHudItems.includes(3) && (
                                        <div className='img-container-HUD'>
                                            <img
                                                className={collectedItems.includes(3) ? 'collected-hud' : ''}
                                                src={pic207}
                                                alt='collect-item-3'
                                            />
                                        </div>
                                    )}

                                {!hiddenHudItems.includes(4) && (
                                    <div className='img-container-HUD'>
                                        <img
                                            className={collectedItems.includes(4) ? 'collected-hud' : ''}
                                            src={pic211}
                                            alt='collect-item-4'
                                        />
                                    </div>
                                )}
                                {!hiddenHudItems.includes(5) && (
                                    <div className='img-container-HUD'>
                                        <img
                                            className={collectedItems.includes(5) ? 'collected-hud' : ''}
                                            src={pic213}
                                            alt='collect-item-5'
                                        />
                                    </div>
                                )}
                                 {!hiddenHudItems.includes(6) && (
                                    <div className='img-container-HUD'>
                                        <img
                                            className={collectedItems.includes(6) ? 'collected-hud' : ''}
                                            src={pic215}
                                            alt='collect-item-6'
                                        />
                                    </div>
                                )}

                                 {!hiddenHudItems.includes(7) && (
                                    <div className='img-container-HUD'>
                                        <img
                                            className={collectedItems.includes(7) ? 'collected-hud' : ''}
                                            src={pic218}
                                            alt='collect-item-7'
                                        />
                                    </div>
                                )}


                                </div>
                            </div>


                        </div>
                    </div>



                </section>
            </section>
          </main>
     );
}
 
export default Level4;